import './index.css';var U = Object.defineProperty;
var J = (e, t, o) => t in e ? U(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o;
var f = (e, t, o) => (J(e, typeof t != "symbol" ? t + "" : t, o), o);
import { defineComponent as A, ref as b, computed as L, watch as H, nextTick as W, onMounted as j, openBlock as g, createElementBlock as k, renderSlot as h, normalizeStyle as K, createElementVNode as p, onUnmounted as Q, normalizeClass as C, normalizeProps as S, guardReactiveProps as B, createTextVNode as T, toDisplayString as G, createBlock as X, Fragment as Y, renderList as Z, withDirectives as ee, vShow as te, createCommentVNode as N, mergeProps as oe } from "vue";
const ne = (e) => {
  import("./index-6b6a8c97.js").then((t) => t.BootstrapVue(e));
}, se = (e) => {
  import("./boot-54088ffb.js").then((t) => t.startAlpine(e));
}, le = (e) => {
  import("./index-f713beaf.js").then((t) => t.BootstrapIsotope(e));
}, ie = (e) => {
  import("./index-b398b5cf.js").then((t) => t.BootstrapMenu(e));
}, Ee = (e) => {
  const { vue: t, alpine: o, isotope: l, menu: r } = e;
  t && ne(t), o && se(o), l && le(l), r && ie(r);
}, re = /* @__PURE__ */ A({
  __name: "MasonryGrid",
  props: {
    watch: {
      type: Array,
      required: !1
    }
  },
  setup(e) {
    const t = e, o = b(), l = b([]), r = new ResizeObserver((s) => {
      s.forEach((a) => {
        m(a.target.parentElement);
      });
    }), d = () => {
      var s;
      return Array.from(((s = o.value) == null ? void 0 : s.children) ?? []);
    }, i = L(() => window.getComputedStyle(o.value));
    function m(s) {
      const a = parseInt(i.value.getPropertyValue("grid-auto-rows")), w = parseInt(i.value.getPropertyValue("--items-row-gap")), v = s.firstElementChild, y = ((v == null ? void 0 : v.getBoundingClientRect().height) ?? 0) + w - a;
      console.log("resize", s), s.style.gridRowEnd = "span " + Math.ceil(y / a);
    }
    function x() {
      d().forEach((s) => m(s));
    }
    function E() {
      l.value.forEach((a) => r.unobserve(a)), l.value.splice(0, l.value.length);
      const s = d().map((a) => a.firstElementChild);
      l.value.push(...s), s.forEach((a) => {
        r.unobserve(a), r.observe(a, { box: "content-box" });
      });
    }
    return t.watch && H(
      t.watch,
      () => {
        W(() => {
          E(), x();
        });
      },
      {
        immediate: !0
      }
    ), j(() => {
      t.watch || (E(), x());
    }), (s, a) => (g(), k("div", {
      class: "wte-masonry-grid",
      ref_key: "grid",
      ref: o
    }, [
      h(s.$slots, "default", {}, void 0, !0)
    ], 512));
  }
});
const ae = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [l, r] of t)
    o[l] = r;
  return o;
}, xe = /* @__PURE__ */ ae(re, [["__scopeId", "data-v-b09736bc"]]), ce = /* @__PURE__ */ p("span", { class: "loader" }, null, -1), de = [
  ce
], ue = /* @__PURE__ */ A({
  __name: "InlineSpinner",
  props: {
    size: {
      type: Number,
      default: () => 20
    },
    stroke: {
      type: Number,
      default: () => 7
    }
  },
  setup(e) {
    return (t, o) => (g(), k("div", {
      class: "wte-inline-spinner",
      style: K({ "--wte-inline-spinner-size": e.size + "px" })
    }, de, 4));
  }
});
function pe(e, t) {
  let o;
  return (...l) => new Promise((r, d) => {
    clearTimeout(o), o = setTimeout(() => {
      try {
        let i = e(...l);
        r(i);
      } catch (i) {
        i instanceof Error && d(i), d(new Error(`An error has occurred:${i}`));
      }
    }, t);
  });
}
const ve = { class: "wte-dropdown-toggle-icon" }, we = /* @__PURE__ */ p("svg", {
  width: "19",
  height: "11",
  viewBox: "0 0 19 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ p("path", {
    d: "M1.5 1.5L9.5 9.5L17.5 1.5",
    stroke: "currentColor",
    "stroke-width": "3",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), he = ["onClick"], fe = { class: "wte-dropdown-option-checkbox" }, ge = { class: "wte-dropdown-option-check-icon" }, me = /* @__PURE__ */ p("svg", {
  width: "12",
  height: "9",
  viewBox: "0 0 12 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ p("path", {
    d: "M11 1L4.125 7.875L1 4.75",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), ye = { class: "wte-dropdown-option-label" }, Ce = /* @__PURE__ */ A({
  __name: "Dropdown",
  props: {
    modelValue: {
      type: Array
    },
    options: {
      type: Array,
      default: () => []
    },
    optionLabel: {
      type: String,
      default: () => "label"
    },
    optionValue: {
      type: String,
      default: () => "value"
    },
    optionDisabled: {
      type: String,
      default: () => "disabled"
    },
    showOptionCheckbox: {
      type: Boolean,
      default: () => !1
    },
    loading: {
      type: Boolean,
      default: () => !1
    },
    disabled: {
      type: Boolean,
      default: () => !1
    },
    multiple: {
      type: Boolean,
      default: () => !1
    },
    placeholder: {
      type: String
    }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const o = e, l = t, r = b(), d = b(), i = b(!1), m = b("below"), x = () => i.value = !1, E = () => i.value = !i.value, s = (n) => {
      var u;
      return (u = o.modelValue) == null ? void 0 : u.includes(w(n));
    }, a = (n) => n[o.optionDisabled], w = (n) => n ? n[o.optionValue] : void 0, v = (n) => n ? n[o.optionLabel] : void 0, $ = L(
      () => {
        var n;
        return (((n = o.modelValue) == null ? void 0 : n.length) ?? 0) > 0 ? o.modelValue.map((u) => o.options.find((c) => w(c) === u)) : void 0;
      }
    ), y = L(() => {
      var n;
      return (n = $.value) == null ? void 0 : n.map((u) => v(u));
    }), V = L(() => {
      var n;
      return ((n = y.value) == null ? void 0 : n.join(", ")) ?? o.placeholder;
    }), O = (n, u) => {
      var D;
      const c = u[o.optionValue] ?? void 0;
      if (!c)
        return;
      const _ = {
        originalEvent: n,
        value: void 0
      };
      (D = o.modelValue) != null && D.includes(c) ? _.value = Array.from(new Set([...o.modelValue ?? []].filter((F) => F !== c))) : _.value = Array.from(/* @__PURE__ */ new Set([...o.modelValue ?? [], c])), l("update:modelValue", _.value), l("change", _);
    }, I = (n) => {
      var u;
      (u = r.value) != null && u.contains(n == null ? void 0 : n.target) || x();
    }, M = () => {
      if (!d.value)
        return;
      const n = r.value.getBoundingClientRect(), u = d.value.getBoundingClientRect();
      window.innerHeight - n.bottom - u.height < 10 ? m.value = "above" : m.value = "below";
    }, P = pe(M, 10);
    return H(i, (n) => {
      n && W(M);
    }), j(() => {
      window.addEventListener("click", I), window.addEventListener("scroll", P);
    }), Q(() => {
      window.removeEventListener("click", I), window.removeEventListener("scroll", P);
    }), (n, u) => (g(), k("div", {
      class: C(["wte-dropdown", `wte-dropdown-options-placement-${m.value}`]),
      ref_key: "el",
      ref: r
    }, [
      h(n.$slots, "default", S(B({
        toggleOptions: E,
        optionsVisible: i.value,
        placeholder: e.placeholder,
        toggleLabel: V.value,
        selectedLabels: y.value,
        loading: e.loading,
        options: e.options,
        getOptionValue: w,
        getOptionLabel: v,
        isOptionSelected: s,
        isOptionDisabled: a,
        toggleOptionItem: O
      })), () => [
        p("div", {
          class: C(["wte-dropdown-toggle", { "wte-options-visible": i.value }]),
          onClick: E
        }, [
          p("div", {
            class: C(["wte-dropdown-toggle-label", { "is-placeholder": !!y.value }])
          }, [
            h(n.$slots, "toggle-label", S(B({ toggleLabel: V.value, selectedLabels: y.value, placeholder: e.placeholder, selectedOptions: $.value, options: e.options })), () => [
              T(G(V.value), 1)
            ])
          ], 2),
          p("div", ve, [
            e.loading ? (g(), X(ue, { key: 0 })) : h(n.$slots, "toggle-icon", { key: 1 }, () => [
              we
            ])
          ])
        ], 2),
        i.value ? (g(), k("div", {
          key: 0,
          class: "wte-dropdown-options",
          ref_key: "optionsEl",
          ref: d
        }, [
          h(n.$slots, "default", S(B({ options: e.options, getOptionValue: w, getOptionLabel: v, isOptionSelected: s, isOptionDisabled: a, toggleOptionItem: O })), () => [
            (g(!0), k(Y, null, Z(e.options, (c) => (g(), k("div", {
              key: w(c),
              class: C(["wte-dropdown-option-item", { selected: s(c), disabled: a(c) }]),
              onClick: (_) => O(_, c)
            }, [
              e.showOptionCheckbox ? h(n.$slots, "option-checkbox", { key: 0 }, () => [
                p("div", fe, [
                  ee(p("div", ge, [
                    h(n.$slots, "check-icon", {}, () => [
                      me
                    ])
                  ], 512), [
                    [te, s(c)]
                  ])
                ])
              ]) : N("", !0),
              p("div", ye, [
                h(n.$slots, "option-label", oe({ ref_for: !0 }, { option: c, getOptionLabel: v, getOptionValue: w, isOptionSelected: s, isOptionDisabled: a }), () => [
                  T(G(v(c)), 1)
                ])
              ])
            ], 10, he))), 128))
          ])
        ], 512)) : N("", !0)
      ])
    ], 2));
  }
});
class q {
  constructor() {
    /** Retrieve the root component DOM node. */
    f(this, "$el");
    /** Retrieve DOM elements marked with x-ref inside the component. */
    f(this, "$refs");
    /** Retrieve the native browser "Event" object within an event listener. */
    f(this, "$event");
    /** Create a CustomEvent and dispatch it using .dispatchEvent() internally. */
    f(this, "$dispatch");
    /** Execute a given expression AFTER Alpine has made its reactive DOM updates. */
    f(this, "$nextTick");
    /** Will fire a provided callback when a component property you "watched" gets changed. */
    f(this, "$watch");
  }
}
function Le(e, t, o) {
  return t.prototype instanceof q && (t = _e(t)), (o ?? window.Alpine).data(e, (...l) => t(...l)), t;
}
function _e(e) {
  return function(...t) {
    let o = new e(...t);
    const l = {};
    function r(d) {
      d && (r(Object.getPrototypeOf(d)), Object.getOwnPropertyNames(d).forEach((i) => {
        l[i] = d[i];
      }));
    }
    return r(o), l;
  };
}
function $e() {
  window.Alpine.onBeforeComponentInitialized((e) => {
    e.$el.hasAttribute("x-title") || e.$data.constructor.prototype instanceof q && e.$el.setAttribute("x-title", e.$data.constructor.name);
  });
}
const R = [];
document.addEventListener("DOMContentLoaded", () => {
  z();
});
document.addEventListener("readystatechange", (e) => {
  document.readyState === "complete" && z();
});
const Ve = (e) => {
  if (typeof e != "function")
    throw Error("Callback must be function.");
  R.push(e), document.readyState === "complete" && z();
}, z = () => {
  for (; R.length > 0; )
    R.shift()();
};
export {
  q as AlpineComponent,
  Ce as Dropdown,
  ue as InlineSpinner,
  xe as MasonryGrid,
  Ee as RunThemeExtensions,
  $e as addTitles,
  _e as convertClassToAlpineConstructor,
  pe as debounce,
  Ve as onReady,
  Le as registerComponent
};
//# sourceMappingURL=index.es.js.map
